import { cn } from '@1trading/react/lib/utils';
import type React from 'react';

import LanguageMenu from '@/components/language-menu';
import Logo from '@/components/layout/logo';
import ProgressBar from '@/components/progress-bar';
import ThemeMenu from '@/components/theme-menu';
import LogoutButton from '@/components/ui/logout-button';
import { staticFeatureFlags } from '@/config/features';
import { useProgress } from '@/context/progress';
import AuthGuard from '@/features/auth/components/auth-guard';

const Header = ({ logoutButton }: { logoutButton?: React.ReactNode }) => {
  const { steps } = useProgress();

  return (
    <header
      className={cn(
        'fixed top-0 left-0 z-20 right-0 grid grid-cols-[auto_1fr_auto] items-center gap-4 px-4 bg-card',
        'md:gap-8 h-[var(--header-height-sm)] md:h-[var(--header-height-md)] md:border-b md:border-border md:dark:border-border/20 md:px-8',
        'lg:px-12',
        steps.length ? '-md:grid-cols-1 -md:px-20' : 'grid-cols-[auto_1fr]',
      )}
    >
      <Logo className={cn(steps.length && '-md:hidden')} />
      {steps.length ? <ProgressBar /> : null}
      <aside className={cn('flex items-center gap-2 -my-2 ml-auto', steps.length && '-md:hidden')}>
        <LanguageMenu />
        {staticFeatureFlags.THEME_SELECTOR ? <ThemeMenu /> : null}
        {logoutButton ? (
          logoutButton
        ) : (
          <AuthGuard>
            <LogoutButton size="sm" />
          </AuthGuard>
        )}
      </aside>
    </header>
  );
};
Header.displayName = 'Header';

export default Header;
